module.exports = __webpack_public_path__ + "img/recommendations.97ac4aac.png";